<template>
  <div class="experiments">
    <v-row v-if="current.user_level=='ADMIN'">
      <v-col class="d-flex justify-start">
      </v-col>
    </v-row>
    <v-data-table
      dense
      :locale="localeTranslate()"
      :headers="tableHeader()" 
      :items="documents"
      item-key="value"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <!--v-icon color="" small class="mr-2" @click="1">mdi-pencil</v-icon-->        
        <v-tooltip top color="indigo">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="downloadDocument(item.value)">
              <v-icon small color="indigo"> mdi-download </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("manage.by_admin.documents.btn.download") }}</span>
        </v-tooltip>
        <v-tooltip top color="green">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="openUploadDialog(item)">
              <v-icon small color="green"> mdi-upload </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("manage.by_admin.documents.btn.upload") }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="uploadDialog" persistent max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeUploadDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_admin.documents.upload.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  :items="documents"
                  item-text="name"
                  item-value="value"
                  v-model="uploadForm.file"
                  no-data-text="No Document Selected"
                  readonly
                ></v-text-field>
                <hr>
              </v-col>
              <v-col cols="12">
                <div>
                  <v-card class="p-2">
                    <h6>{{ $t("manage.by_admin.documents.upload.header") }}</h6>                    
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col cols="12">
                          <v-file-input
                            chips
                            accept=".pdf"
                            :label="uploadDocumentLabel('file')"
                            :placeholder="uploadDocumentLabel('file_place_hloder')"
                            prepend-icon="mdi-paperclip"
                            v-model="uploadForm.new_file"
                          >
                          <template v-slot:selection="{ text }">
                              <v-chip small color="primary">
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn v-if="uploadForm.new_file!=null" color="primary" @click="uploadDocument">
                        <v-icon>mdi-upload</v-icon>{{ $t("manage.by_admin.documents.upload.btn.upload") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <!--vue-pdf-embed :source="pdfSource" /-->
        </v-row>
      </v-card>
    </v-dialog>    
  </div>
</template>

<script>
import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);
export default {
  name: "CreateBookSlot",
  data: function () {
    return {
      documents: [
        {
          text: "User Guide",
          text_chi: "User Guide",
          value: "BL365-User_Guide"
        },
        {
          text: "Incharge Manual",
          text_chi: "Incharge Manual",
          value: "BL365-Incharge_Manual"
        },
        {
          text: "Key Function of Incharge",
          text_chi: "Key Function of Incharge",
          value: "BL365-Key_Functions_of_Incharge"
        },
      ],
      assignCheckbox: false,
      menu: false,
      dialog: false,
      dialog_add_experiment: false,
      uploadDialog: false,

      manualDialog: false,
      removeManualDialog: false,
      uploadNewManualDialog: false,
      manualItem: null,
      photoDialog: false,
      removeAllPhotoDialog: false,
      uploadNewPhotoDialog: false,
      photoItem: null,
      fields: [
        {
          text:"BIOLOGY",
          text_chi: "生物",
          value:"Biology"
        },
        {
          text:"CHEMISTRY",
          text_chi: "化學",
          value:"Chemistry"
        },
        {
          text:"PHYSICS",
          text_chi: "物理",
          value:"Physics"
        },
        {
          text:"ENGINEERING",
          text_chi: "工程",
          value:"Engineering"
        },
      ],
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
      },
      uploadForm:{
        file: "",
        new_file: null,
      },
      manualForm:{
        experiment: "",
        old_file_path: "",
        old_filename: "",
        new_file: null,
        exist: false,
      },
      photoForm:{
        experiment: "",
        photos: [],
        new_photos: null,
        exist: false,
      },
      api: {
        experiments: [],
      },
      form: {
        new_experiment: "",
        new_experiment_name: "",
        new_experiment_field: "",
      },
      headers: [
        { text: 'Documents', value: 'value' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headers_chi: [
        { text: '文檔', value: 'value' },
        { text: '操作', value: 'actions', sortable: false },
      ],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
  },  
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    isValid: function(){
      var self = this;
      if(self.form.new_experiment.trim()==""){
        alert("Missing experiment ID");
        return false;
      }
      if(self.form.new_experiment_name.trim()==""){
        alert("Missing experiment name");
        return false;
      }
      if(self.form.new_experiment_field==""){
        alert("Missing experiment field");
        return false;
      }
      return true;
    },
    uploadDocumentLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc'){
        if (label=='select_text') return "文檔"
        else if (label=='file') return "新檔案"
        else if (label=='file_place_hloder') return "選擇PDF格式的檔案"
        else if (label=='field_text') return "text_chi"
      }
      else {
        if (label=='select_text') return "Document"
        else if (label=='file') return "New File Input"
        else if (label=='file_place_hloder') return "Select file in PDF format"
        else if (label=='field_text') return "text"
      }
    },
    tableHeader(){
      var self = this;
      if(self.$i18n.locale=='tc')
        return self.headers_chi;
      else
        return self.headers;
    },
    openUploadDialog(item){
      var self = this;
      self.uploadItem = item;
      self.uploadDialog = true;
      self.uploadForm.file = item.value;
      self.uploadForm.new_file = null;
    },
    closeUploadDialog(){
      var self = this;
      self.uploadDialog = false;
      self.uploadForm.new_file = null;
    },
    
    uploadDocument(){
      var self = this;
      if(self.uploadForm.new_file){
        apiManagement.uploadDocument(self.uploadForm.file, self.uploadForm.new_file, self.current.username, self.current.auth_token)
        .then((response) => {          
          if(response.status == "success"){
              self.$store.commit("showSnackBar", self.uploadForm.file + " is uploaded");
          }
          else if(response.status == "fail"){
              self.$store.commit("showSnackBar", response.error);
          }
          else {
            self.$store.commit("showSnackBar", "Error, please try again.");
          }
          self.closeUploadDialog();
        });
      }
      else {
        alert("Please select a pdf file");
      }
    },
    downloadDocument(file){
      var self = this;
      window.open(
        "https://labxra.edu.hk/remotelab/files/documents/"+file+".pdf"
      );
    },
    goTo(school_id){
      var self = this;
      self.$router.push("/management/school/"+school_id);
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>